<template>
  <div class="dynamics-migration-plan">
    <bootstrap-loader v-if="loading" />
    <b-alert v-else-if="error" variant="danger" show class="m-3">
      {{ error }}
    </b-alert>
    <iframe
      v-else
      :srcdoc="html"
      sandbox="allow-scripts allow-popups"
      class="w-100 border-0"
      title="Entwurf Dynamics-Migration"
    ></iframe>
  </div>
</template>

<script>
import axios from 'axios';
import BootstrapLoader from '@gid/vue-common/components/BootstrapLoader';

export default {
  components: {
    BootstrapLoader,
  },
  data() {
    return {
      html: '',
      loading: true,
      error: null,
    };
  },
  async created() {
    // Fetched through gid-api rather than served as a static asset, so the
    // document stays behind authentication.
    try {
      const { data } = await axios.get('/api/admin/dynamics-migration-plan');
      this.html = data;
    } catch (e) {
      this.error = this.$t('dynamicsMigrationPlan.loadError');
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.dynamics-migration-plan iframe {
  display: block;
  height: calc(100vh - 4rem);
}
</style>
